// credit belongs to this answer: https://stackoverflow.com/a/38829074
export function mapObj<K extends string, U, V>(
  obj: Record<K, U>,
  f: (entry: [K, U]) => Record<K, V>
): Record<K, V> {
  return Object.assign({}, ...Object.entries(obj).map(f));
}
